import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetOrderbyIdQuery } from "../../Services/OrdersAPI";
import { useParams } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import EditTrackingDetails from "./editTrackId"

function AddCategory() {
  const { id, orderid } = useParams();
  const { data: orderDetail, isLoading: loadingContent, error, refetch: refetchorderDetail } = useGetOrderbyIdQuery({ id, orderid });
  const [key, setKey] = useState("home");
  useEffect(() => {
    refetchorderDetail();
  }, [refetchorderDetail])


  if (loadingContent) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Order Details</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/order-list">
            <span>Orders</span>
          </Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">View</span>
        </p>
      </div>

      <div className="content-wrapper order-details">

        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
          <Tab eventKey="home" title="Order Details">
            <form>
              <div className="row">
                {/* Category Name */}
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Order ID
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                    
                      value={orderDetail?.order?.order_id}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Track ID
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.track_order_id}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Tracking URL
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                      value={orderDetail?.order?.order_track_url}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Total Amount
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                      
                      value={orderDetail?.order?.final_total_amount}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Total Items
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.total_items}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Payment Status
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.payment_status}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                    
                      value={
                        orderDetail?.order?.first_name +
                        " " +
                        orderDetail?.order?.last_name
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Company Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                      
                      value={orderDetail?.order?.company_name}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Country
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.country}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Street Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                      
                      value={orderDetail?.order?.street_address}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Town/City
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.town_city}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                      
                      value={orderDetail?.order?.state}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Pin Code
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                     
                      value={orderDetail?.order?.pin_code}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-4 text-start">
                    <label htmlFor="category_name" className="form-label">
                      Email
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="category_name"
                    
                      value={orderDetail?.order?.email}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <h5 className="mt-5 mb-4">Product Items</h5>

              <div className="table-responsive">
                {orderDetail?.order?.items?.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderDetail.order.items.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={item.product_main_image_url_large}
                              alt={item.product_name}
                              width="80"
                              height="80"
                            />
                          </td>
                          <td>{item.product_name}</td>
                          <td>{item.quantity}</td>
                          <td>${item.product_selling_unit_price}</td>
                          <td>${item.line_total_selling_price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No items found</p>
                )}
              </div>

              <h5 className="mt-5 mb-4">Billing Address</h5>
              {orderDetail?.billing_address ? (
                <div className="address-card">
                  <p>
                    <strong>Name:</strong>{" "}
                    {orderDetail?.billing_address?.first_name}{" "}
                    {orderDetail?.billing_address.last_name}
                  </p>
                  <p>
                    <strong>Company:</strong>{" "}
                    {orderDetail?.billing_address?.company_name}
                  </p>
                  <p>
                    <strong>Street:</strong>{" "}
                    {orderDetail?.billing_address.street_address}
                  </p>
                  <p>
                    <strong>City:</strong>{" "}
                    {orderDetail?.billing_address.town_city},{" "}
                    {orderDetail?.billing_address.state}
                  </p>
                  <p>
                    <strong>Country:</strong>{" "}
                    {orderDetail?.billing_address.country}
                  </p>
                  <p>
                    <strong>Pin Code:</strong>{" "}
                    {orderDetail?.billing_address.pin_code}
                  </p>
                  <p>
                    <strong>Phone:</strong> {orderDetail?.billing_address.phone}
                  </p>
                  <p>
                    <strong>Email:</strong> {orderDetail?.billing_address.email}
                  </p>
                </div>
              ) : (
                <p>No billing address found</p>
              )}
              <hr />
              <h5 className="mt-5 mb-4">Shipping Address</h5>
              {orderDetail?.shipping_address ? (
                <div className="address-card">
                  <p>
                    <strong>Name:</strong>{" "}
                    {orderDetail?.shipping_address?.first_name}{" "}
                    {orderDetail?.shipping_address?.last_name}
                  </p>
                  <p>
                    <strong>Company:</strong>{" "}
                    {orderDetail?.shipping_address?.company_name}
                  </p>
                  <p>
                    <strong>Street:</strong>{" "}
                    {orderDetail?.shipping_address?.street_address}
                  </p>
                  <p>
                    <strong>City:</strong>{" "}
                    {orderDetail?.shipping_address?.town_city},{" "}
                    {orderDetail?.shipping_address?.state}
                  </p>
                  <p>
                    <strong>Country:</strong>{" "}
                    {orderDetail?.shipping_address?.country}
                  </p>
                  <p>
                    <strong>Pin Code:</strong>{" "}
                    {orderDetail?.shipping_address?.pin_code}
                  </p>
                  <p>
                    <strong>Phone:</strong> {orderDetail?.shipping_address?.phone}
                  </p>
                  <p>
                    <strong>Email:</strong> {orderDetail?.shipping_address?.email}
                  </p>
                </div>
              ) : (
                <p>No shipping address found</p>
              )}
            </form>
          </Tab>
          <Tab eventKey="profile" title="Edit Tracking Details">
            <EditTrackingDetails id={id} orderid={orderid} />
          </Tab>

        </Tabs>


      </div>
    </div>
  );
}

export default AddCategory;
